export default "__VITE_ASSET__OICFIvTc__"